(function () {
    'use strict';

    angular
        .module('womenCellApp')
        .controller('PressNoteViewController', PressNoteViewController);

    PressNoteViewController.$inject = ['$scope','$stateParams','$uibModalInstance'];

    function PressNoteViewController($scope,$stateParams, $uibModalInstance) {
        var vm = this;
        $scope.filename=$stateParams.filename;
        vm.closeView=closeView;

        function closeView()
        {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();
